import { createContext, useContext, useState, type ReactNode } from 'react'
import { PackOptimaModal } from './PackOptimaComponents'

type PackOptimaModalContextType = {
  openModal: (discountAmount?: number) => void
  closeModal: () => void
  isOpen: boolean
}

const PackOptimaModalContext = createContext<
  PackOptimaModalContextType | undefined
>(undefined)

export function PackOptimaModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [discountAmount, setDiscountAmount] = useState<number | undefined>(
    undefined,
  )
  const openModal = (discountAmount?: number) => {
    setDiscountAmount(discountAmount)
    setIsOpen(true)
  }
  const closeModal = () => {
    setDiscountAmount(undefined)
    setIsOpen(false)
  }

  return (
    <PackOptimaModalContext.Provider value={{ openModal, closeModal, isOpen }}>
      {children}
      <PackOptimaModal
        isOpen={isOpen}
        onClose={closeModal}
        discountAmount={discountAmount}
      />
    </PackOptimaModalContext.Provider>
  )
}

export function usePackOptimaModal() {
  const context = useContext(PackOptimaModalContext)
  if (context === undefined) {
    throw new Error(
      'usePackOptimaModal must be used within a PackOptimaModalProvider',
    )
  }
  return context
}
